import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (form.password.length < 6) {
            toast.error("La contraseña debe tener al menos 6 caracteres");
            return;
        }
        setSubmitting(true);
        const res = await register(form);
        setSubmitting(false);
        if (res.ok) {
            toast.success("¡Cuenta creada! Bienvenido a la dulcería 🎉");
            navigate("/perfil");
        } else {
            toast.error(res.error);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="register-page">
            <div className="w-full max-w-md bg-white border border-border rounded-3xl shadow-xl p-8">
                <div className="text-center mb-6">
                    <div className="w-14 h-14 rounded-2xl bg-marigold text-cocoa flex items-center justify-center font-display font-bold text-2xl mx-auto mb-3">+</div>
                    <h1 className="font-display text-2xl font-semibold text-cocoa">Crear cuenta</h1>
                    <p className="text-sm text-muted-foreground">Únete y empieza a sumar puntos 🎁</p>
                </div>
                <form onSubmit={onSubmit} className="space-y-4">
                    <div>
                        <label className="text-sm font-medium text-cocoa">Nombre completo</label>
                        <input
                            data-testid="register-name"
                            required
                            value={form.name}
                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                            className="mt-1 w-full px-3 py-2.5 rounded-xl border border-border focus:border-mexred focus:ring-2 focus:ring-mexred/20 outline-none"
                        />
                    </div>
                    <div>
                        <label className="text-sm font-medium text-cocoa">Correo</label>
                        <input
                            data-testid="register-email"
                            type="email"
                            required
                            value={form.email}
                            onChange={(e) => setForm({ ...form, email: e.target.value })}
                            className="mt-1 w-full px-3 py-2.5 rounded-xl border border-border focus:border-mexred focus:ring-2 focus:ring-mexred/20 outline-none"
                        />
                    </div>
                    <div>
                        <label className="text-sm font-medium text-cocoa">Teléfono (opcional)</label>
                        <input
                            data-testid="register-phone"
                            value={form.phone}
                            onChange={(e) => setForm({ ...form, phone: e.target.value })}
                            className="mt-1 w-full px-3 py-2.5 rounded-xl border border-border focus:border-mexred focus:ring-2 focus:ring-mexred/20 outline-none"
                        />
                    </div>
                    <div>
                        <label className="text-sm font-medium text-cocoa">Contraseña (mínimo 6)</label>
                        <input
                            data-testid="register-password"
                            type="password"
                            required
                            value={form.password}
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                            className="mt-1 w-full px-3 py-2.5 rounded-xl border border-border focus:border-mexred focus:ring-2 focus:ring-mexred/20 outline-none"
                        />
                    </div>
                    <button
                        data-testid="register-submit-btn"
                        disabled={submitting}
                        className="w-full bg-marigold hover:bg-marigold/90 disabled:bg-muted text-cocoa rounded-full py-3 font-semibold transition-all shadow-md"
                    >
                        {submitting ? "Creando..." : "Crear cuenta"}
                    </button>
                </form>
                <p className="text-center text-sm text-muted-foreground mt-5">
                    ¿Ya tienes cuenta?{" "}
                    <Link to="/login" className="text-cocoa font-semibold hover:underline">
                        Inicia sesión
                    </Link>
                </p>
            </div>
        </div>
    );
}
